import styled from 'styled-components';

export const LoadingContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  background-color: black;
`

export const OverlayContainer = styled.div`
  position: fixed;
  max-width: 500px;
  max-height: 500px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  z-index: 100;
`;

interface ControlPanelProps {
  collapsed: boolean;
}

export const ControlPanelContainer = styled(
  OverlayContainer,
)<ControlPanelProps>`
  width: 500px;
  height: 150px;
  bottom: 10px;
  left: ${({ collapsed }) => (collapsed ? '-510px' : '10px')};
  top: auto;
  transform: none;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 10px;
  border-radius: 10px;
  transition: left 0.3s ease;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 100;
`;

export const ControlRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const ActionButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  padding-top: 30px;
`;

export const SliderContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  margin: 0 5px;
`;

export const SideButtonColumn = styled.div`
  position: absolute;
  left: 10px;
  bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TopLeftButton = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
`;

export const TopRightButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const MuteButton = styled.div`
  position: absolute;
  top: 10px;
  right: 60px;
`;

export const WinnerScreen = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const WinnerContent = styled.div`
  flex-direction: column;
  display: flex;
`;

export const SetupScreenContainer = styled(OverlayContainer)`
  width: 570px;
  max-width: 800px;
  max-height: 912px;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.85);
  color: white;
`;

export const SetupContent = styled.div`
  padding-top: 60px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex: 1;
  width: 100%;
`;

export const PlayerSetupSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ScenarioSetupSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const PlayerSetupRow = styled(ControlRow)`
  margin-bottom: 10px;
`;

export const PlayersTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
`;

export const PlayerRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const SimpleSetup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
`;

export const AdvancedSetup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`;

export const InfoBox = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 200px;
  height: 150px;
  background-color: rgba(50, 50, 50, 0.9);
  color: white;
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  overflow-y: auto;
`;

export const DropdownGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`